export default __webpack_public_path__ + "static/soehne-web-extraleicht-kursiv-cceaf4382db9454badc53ecf004671f3.eot";